module.exports = __webpack_public_path__ + "img/03.efa972f1.png";